import { ClientException, ClientExceptionConstructor } from './client-exception';

export class NfcTagLostException extends ClientException implements ClientExceptionConstructor {
  constructor(message?: string, error?: Error) {
    super(message, error);
    this.name = 'NfcTagLostException';
  }

  static fromError(error: Error): NfcTagLostException {
    return new this(error.message, error);
  }
}
